export default "__VITE_ASSET__CJsCdfYf__"